require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/object/assign.js
 ** module id = 174
 ** module chunks = 0
 **/